import { loadable } from '@wix/communities-forum-client-commons/dist/src/services/loadable';

export default loadable(() =>
  import(/* webpackChunkName: "forum-rce-frameless" */ '../rich-content-editor'),
);
